import useWorkflowNavigation from '@/frontend/pages/Dashboard/Workflows/useWorkflowNavigation'
import { Link } from '@inertiajs/react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { displayDate, displayDuration } from '@/frontend/pages/Dashboard/Workflows/presentation'
import type { Copy, RecentExecutions } from '@/frontend/pages/Dashboard/Workflows/types'

const tones = {
  running: 'bg-[#1F94D2]', completed: 'bg-success/40 dark:bg-success/60', failed: 'bg-destructive',
  canceled: 'bg-muted-foreground/50', terminated: 'bg-destructive/60', timed_out: 'bg-warning', continued_as_new: 'bg-brand/50',
}

export default function WorkflowHistory({ data, copy }: { data: RecentExecutions; copy: Copy }) {
  const { executionPath } = useWorkflowNavigation()
  const historyLabel = data.coverage.complete ? copy.catalog.history_complete : copy.catalog.history_partial
  return <div className="space-y-1.5">
    {data.items.length > 0 ? <ul aria-label={historyLabel} className="flex min-h-5 items-end gap-[3px]">
      {[...data.items].reverse().map((execution) => {
        const label = `${copy.execution_states[execution.status]}; ${copy.execution.started_at}: ${displayDate(execution.started_at, copy.shared.not_informed)}; ${execution.elapsed_ms !== null ? copy.shared.elapsed : copy.shared.duration}: ${displayDuration(execution.duration_ms ?? execution.elapsed_ms, copy)}`
        return <li key={`${execution.execution_id}:${execution.temporal_run_id}`} className="flex shrink-0">
          <Tooltip><TooltipTrigger asChild><Link href={executionPath(execution)} aria-label={`${copy.catalog.run_label.replace('%{run}', execution.temporal_run_id)}: ${label}`}
            className={cn('block h-[18px] w-[6px] rounded-[2px] outline-offset-2 transition-opacity hover:opacity-70 focus-visible:outline-2 focus-visible:outline-ring', tones[execution.status])}>
            <span className="sr-only">{label}</span>
          </Link></TooltipTrigger><TooltipContent className="max-w-72 text-xs leading-5">{label}</TooltipContent></Tooltip>
        </li>
      })}
    </ul> : <p className="text-xs text-muted-foreground">{copy.catalog.no_executions}</p>}
    {!data.coverage.complete && <p className="text-[11px] leading-4 text-muted-foreground">{copy.catalog.history_partial}</p>}
  </div>
}
